<template>
  <v-dialog v-model="showDialog" persistent max-width="400">
    <v-card>
      <v-card-title class="headline">Inactividad</v-card-title>
      <v-card-text>
        <v-row>
          <v-col v-if="state=='warn'">
            <strong>Tu tiempo de sesión esta pronto a expirar</strong>. Presiona continuar para obtener más tiempo.
          </v-col>
          <v-col v-else>
            Tu tiempo de sesión ha expirado. Deberás reingresar al portal.
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn v-if="state == 'warn'" :disabled="loading" :loading="loading" color="secondary" @click="refresh">Continuar</v-btn>
        <v-btn v-if="state == 'expired'" :disabled="loading" :loading="loading" color="secondary" @click="logout">Ir al login</v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

function listenActivity() {
    const events = ['mousemove', 'mousedown', 'keypress', 'DOMMouseScroll', 'mousewheel', 'touchmove', 'MSPointerMove'];
    let value = false;
    function handleActivity() {
        events.map(ev => document.removeEventListener(ev, handleActivity, false));
        value = true;
    }
    function stop() {
        events.map(ev => document.removeEventListener(ev, handleActivity, false));
    }

    events.map(ev => document.addEventListener(ev, handleActivity, false));

    return function getValue() {
      stop();
      return value;
    }
}

function sessionWatcher() {
  let checkActivityAt;
  let refreshAt;
  let expiresAt;
  let _onStateChange = () => {};

  let state = 'inactive';
  let timer;

  const transitions = {
    inactive() {},
    initial() {
      const deltaT = Math.max(0, checkActivityAt - window.DATE.getTime());
      timer = setTimeout(() => transTo('checkActivity'), deltaT);
    },
    checkActivity() {
      const deltaT = Math.max(0, refreshAt - window.DATE.getTime());
      let hasActivity = listenActivity();
      timer = setTimeout(() => hasActivity() ? transTo('refreshing') : transTo('warn'), deltaT);
    },
    refreshing() {
      timer = setTimeout(() => transTo('warn'), 10000);
    },
    warn() {
      const deltaT = Math.max(0, expiresAt - window.DATE.getTime());
      timer = setTimeout(() => transTo('expired'), deltaT);
    },
    expired() {
      window.onbeforeunload = null;
    },
  };

  function transTo(newState) {
    clearTimeout(timer);
    state = newState;
    transitions[state]();
    _onStateChange(state);
  }

  return {
    getState() {
      return state;
    },
    start(opts) {
      checkActivityAt = opts.checkActivityAt;
      refreshAt = opts.refreshAt;
      expiresAt = opts.expiresAt;
      transTo('initial');
    },
    stop() {
      transTo('inactive');
    },
    expired() {
      transTo('expired');
    },
    onStateChange(fn) {
      _onStateChange = fn;
    }
  }
}

const w = sessionWatcher();

export default {
  data() {
    return {
      state: 'initial',
      loading: false,
    };
  },

  computed: {
    showDialog() {
      return this.state == 'warn' || this.state == 'expired';
    }
  },

  created() {
    w.onStateChange(state => {
      if (state === 'refreshing') {
        this.refresh();
      }
      this.state = state;
    });

    this.$store.watch(state => state.session.expiresAt, expiresAt => {
      if (!expiresAt) {
        w.stop();
        return;
      }

      w.start({
        checkActivityAt: expiresAt - process.env.VUE_APP_REFRESHER_START_LISTENING * 1000,
        refreshAt: expiresAt - process.env.VUE_APP_REFRESHER_REFRESH * 1000,
        expiresAt,
      });

    }, { immediate: true });
  },

  methods: {
    refresh() {
      this.loading = true;
      return this.$store.dispatch('session/refresh')
        .then(() => {this.loading = false;})
        .then(() => {this.loading = false;})
        .catch(e => {
          if (e.message === 'Sesión expirada') {
            w.expired();
          }
          this.loading = false;
        });
    },
    logout() {
      this.loading = true;
      return this.$store.dispatch('session/logout')
        .then(() => {this.loading = false;})
        .catch(() => {this.loading = false;})
    }
  },
};
</script>
